import React from 'react';

interface SimilarityBarProps {
  value: number; // 0-1
}

function getColorClass(value: number): string {
  if (value >= 0.9) return 'green';
  if (value >= 0.75) return 'accent';
  if (value >= 0.6) return 'warning';
  return 'danger';
}

export const SimilarityBar: React.FC<SimilarityBarProps> = ({ value }) => {
  const color = getColorClass(value);
  const pct = Math.round(value * 100);

  return (
    <div className="similarity-bar">
      <div className="similarity-track">
        <div className={`similarity-fill ${color}`} style={{ width: `${pct}%` }} />
      </div>
      <span className={`similarity-label ${color}`}>{pct}%</span>
    </div>
  );
};
